// @codekit-prepend "_gallery.js";
// @codekit-prepend "_list.js";
// @codekit-prepend "_price.js";
// @codekit-prepend "search/_search.js";
// @codekit-prepend "_tools.js";


function OC__Property_calendar_2( pm_options )
{
	// -----------------------------------------------
	// Constructor.
	
	// Store path to calendar object.
	this.id = pm_options.id;
	
	// Check if page element is available
	if( jQuery(this.id).length == 0 )
	{
		console.log('Calendar found no page element with the given identifier');
		return( false );
	}
	
	// Determine the length of the calendar date span.
	this.max_date = (typeof pm_options.max_date === "undefined") ? '+2Y' : pm_options.max_date;
	
	// Determine the date format to return.
	this.date_format = (typeof pm_options.date_format === "undefined") ? 'd MM yy' : pm_options.date_format;
	
	// Determine how many months to show in the calendar. Default to 1.
	this.month_count = (typeof pm_options.month_count === "undefined") ? 1 : pm_options.month_count;
	
	// Store booking data for this calendar.
	this.booking_data = get_booking_data(this.id);
	
	// Store latest booking data as static variable for datepicker to access.
	var g_booking_data = this.booking_data;
	
	// Starting date for calendar. Today - disable previous dates.
	var date_today = new Date();
	
	// Set up calendar. Requires jQueryUI.
	jQuery(this.id).datepicker({
		minDate: date_today,
		maxDate: this.max_date,
		dateFormat: this.date_format,
		numberOfMonths: this.month_count,
		beforeShowDay: function(pm_date){
			
			var date = pm_date.toString();
			
			//console.log('BOOK: ', g_booking_data);
			
			var code = get_code_by_date( date, g_booking_data );
			var date_yesterday = moment(date).add(-1, 'days').format('YYYY-MM-DD');//date.setDate(date.getDate() - 1);
			var code_yesterday = get_code_by_date( date_yesterday, g_booking_data );
			var date_tomorrow = moment(date).add(+1, 'days').format('YYYY-MM-DD');
			var code_tomorrow = get_code_by_date( date_tomorrow, g_booking_data );
			//console.log('CODE ', code, ',', code_yesterday, ',', code_tomorrow);
			
			var options = {};
			options.today = { date: date, code: code };
			options.yesterday = { date: date_yesterday, code: code_yesterday };
			options.tomorrow = { date: date_tomorrow, code: code_tomorrow };
			
			var booking_info = get_booking_info( options );
			console.log(date,booking_info);
			
			var selectable = booking_info.selectable;
			var booking_class = booking_info.booking_class;
			var tool_tip = booking_info.tool_tip;
				
			// Is date selectable. Also return booking class and tool tip.
			return( [selectable, booking_class, tool_tip] );
			
		}
	});
	
	// -----------------------------------------------
	
	
	// Get booking information based on code information.
	function get_booking_info( pm_options )
	{
		var code_today = pm_options.today.code;
		var code_yesterday = pm_options.yesterday.code;
		var code_tomorrow = pm_options.tomorrow.code;
		
		var tool_tip_label_available = 'Available';
		var tool_tip_label_unavailable = 'Unavailable';
		
		// Defaults.
		var selectable = true;
		var booking_class = '';
		var tool_tip = tool_tip_label_available;
		
		switch( code_today )
		{
			// Undefined
			case( '-1' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				break;
			
			// Date available for booking.
			case( '0' ):
				selectable = true;
				tool_tip = tool_tip_label_available;
				booking_class = 'code-0';
				
				// Test for booking end. Are we going from available to not available.
				if( code_yesterday == '2' )
				{
					booking_class += ' booking-end';
				}
				
				break;
			
			// Booking pending
			case( '1' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				booking_class = 'booking pending code-1';
				break;
			
			// Booking.	
			case( '2' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				booking_class = 'booking code-2';
				
				// Test for booking start. Are we going from available to not available.
				if( code_yesterday == '0' )
				{
					booking_class += ' booking-start';
				}
				
				// Test for booking end. Are we going from available to not available.
				//if( code_tomorrow == '0' )
				//{
				//	booking_class += ' booking-end';
				//}
				
				break;
			
			// Booking (owner)	
			case( '3' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				booking_class = 'booking owner code-3';
				break;
			
			// Booking (back-to-back)
			case( '4' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				booking_class = 'back-to-back code-4';
				break;
				
			default:
				break;
		}
		
		var booking_info = {};
		booking_info.code = code_today;
		booking_info.selectable = selectable;
		booking_info.booking_class = booking_class;
		booking_info.tool_tip = tool_tip;
		
		return(booking_info);
	}
	
	
	// Get booking code for a particular date.
	function get_code_by_date( pm_date, pm_booking_data )
	{
		var booking_data = pm_booking_data;
		var code = '-1';
		var date_id = moment(pm_date).format('YYYY-MM-DD');
		var date_data = booking_data[date_id];
		
		if(typeof date_data != 'undefined')
		{
			code = date_data.code;
		}
		
		//code = parseInt(code);
		
		return(code);
	}
	
	
	// Assemble booking data from single digit code list.
	function get_booking_data( pm_id )
	{
		// Booking data is series of single digit codes inserted as attribute.
		var booking_data_string = jQuery(pm_id).attr('data-oc-booking');
		var booking_data_array = booking_data_string.split('');
		
		// Iterate through digits and assemble booking data.
		var booking_data = {};
		for( var i = 0; i < booking_data_array.length; i++ )
		{
			var date_today = new Date();
			var date = new Date();
			date.setDate(date_today.getDate()+i);
			var date_string = moment(date).format('YYYY-MM-DD');
			var day_code = booking_data_array[i];
			
			var day_data = {};
			day_data.code = day_code;
			day_data.date = date;
			day_data.date_human = date_string;
			
			//booking_data.push(day_data);
			booking_data[date_string] = day_data;
		}
		
		return(booking_data);
	}
		
	//this.get_booking_data = function()
	//{
	//	return this.booking_data;
	//} 
}


/*
	Requires Monent.js library for dates
	Requires jQueryUI for DatePicker. 
*/
OC__Property_calendar = {
	
	booking_data : []
	,
	init : function( pm_options )
	{
		var date_today = new Date(); // Today. Disable previous dates.
		
		var calendar_id = pm_options.id;
		var min_date = moment().format('YYYY-MM-DD'); // Today. Disable previous dates.
		var max_date = pm_options.max_date;
		var date_format = pm_options.date_format;
		var month_count = pm_options.month_count;
		
		// Get booking data.
		var booking_data = OC__Property_calendar.get_booking_data(calendar_id);
		OC__Property_calendar.booking_data = booking_data;
		console.log(booking_data);
		
		// Construct date picker (jQueryUI)
		jQuery(calendar_id).datepicker({
			minDate: date_today,
			maxDate: max_date,
			dateFormat: date_format,
			numberOfMonths: month_count,
			beforeShowDay: function(pm_date){
				
				var date = pm_date.toString();
				var code = OC__Property_calendar.get_code_by_date( pm_date );
				var date_yesterday = moment(date).add(-1, 'days').format('YYYY-MM-DD');//date.setDate(date.getDate() - 1);
				var code_yesterday = OC__Property_calendar.get_code_by_date( date_yesterday );
				var date_tomorrow = moment(date).add(+1, 'days').format('YYYY-MM-DD');
				var code_tomorrow = OC__Property_calendar.get_code_by_date( date_tomorrow );
				
				//console.log('DATE YESTERDAY: ', date_yesterday, code_yesterday);
				//console.log('DATE: ', date, code);
				//console.log('DATE TOMORROW: ', date_tomorrow, code_tomorrow);
				
				var options = {};
				options.today = { date: date, code: code };
				options.yesterday = { date: date_yesterday, code: code_yesterday };
				options.tomorrow = { date: date_tomorrow, code: code_tomorrow };
				
				var booking_info = OC__Property_calendar.get_booking_info( options );
				
				console.log(date,booking_info);
				
				var selectable = booking_info.selectable;
				var booking_class = booking_info.booking_class;
				var tool_tip = booking_info.tool_tip;
				
				// Is date selectable.
				return( [selectable, booking_class, tool_tip] );
			}
		});
	}
	,
	//Assemble booking data from single digit code list.
	get_booking_data : function( pm_calendar_id )
	{
		// Booking data is series of single digit codes inserted as attribute.
		var booking_data_string = jQuery(pm_calendar_id).attr('data-booking');
		var booking_data_array = booking_data_string.split('');
		
		// Iterate through digits and assemble booking data.
		var booking_data = {};
		for( var i = 0; i < booking_data_array.length; i++ )
		{
			var date_today = new Date();
			var date = new Date();
			date.setDate(date_today.getDate()+i);
			var date_string = moment(date).format('YYYY-MM-DD');
			var day_code = booking_data_array[i];
			
			var day_data = {};
			day_data.code = day_code;
			day_data.date = date;
			day_data.date_human = date_string;
			
			//booking_data.push(day_data);
			booking_data[date_string] = day_data;
		}
		
		return(booking_data);		
	}
	,
	get_code_by_date : function( pm_date )
	{
		var booking_data = OC__Property_calendar.booking_data;
		var code = '-1';
		var date_id = moment(pm_date).format('YYYY-MM-DD');
		var date_data = booking_data[date_id];
		
		if(typeof date_data != 'undefined')
		{
			code = date_data.code;
		}
		
		//code = parseInt(code);
		
		return(code);
	}
	,
	get_booking_info : function( pm_options )
	{
		var code_today = pm_options.today.code;
		var code_yesterday = pm_options.yesterday.code;
		var code_tomorrow = pm_options.tomorrow.code;
		
		var tool_tip_label_available = 'Available';
		var tool_tip_label_unavailable = 'Unavailable';
		
		// Defaults.
		var selectable = true;
		var booking_class = '';
		var tool_tip = tool_tip_label_available;
		
		switch( code_today )
		{
			// Undefined
			case( '-1' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				break;
			
			// Date available for booking.
			case( '0' ):
				selectable = true;
				tool_tip = tool_tip_label_available;
				booking_class = 'code-0';
				
				// Test for booking end. Are we going from available to not available.
				if( code_yesterday == '2' )
				{
					booking_class += ' booking-end';
				}
				
				break;
			
			// Booking pending
			case( '1' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				booking_class = 'booking pending code-1';
				break;
			
			// Booking.	
			case( '2' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				booking_class = 'booking code-2';
				
				// Test for booking start. Are we going from available to not available.
				if( code_yesterday == '0' )
				{
					booking_class += ' booking-start';
				}
				
				// Test for booking end. Are we going from available to not available.
				//if( code_tomorrow == '0' )
				//{
				//	booking_class += ' booking-end';
				//}
				
				break;
			
			// Booking (owner)	
			case( '3' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				booking_class = 'booking owner code-3';
				break;
			
			// Booking (back-to-back)
			case( '4' ):
				selectable = false;
				tool_tip = tool_tip_label_unavailable;
				booking_class = 'back-to-back code-4';
				break;
				
			default:
				break;
		}
		
		var booking_info = {};
		booking_info.code = code_today;
		booking_info.selectable = selectable;
		booking_info.booking_class = booking_class;
		booking_info.tool_tip = tool_tip;
		
		return(booking_info);
	}
};

jQuery(document).ready(function(jQuery){
	
	var options = {};
	options.id = '#calendar-test';
	var calendar_1 = new OC__Property_calendar_2(options);
	
	//console.log('CALENDAR', calendar_1, calendar_1.booking_data);
	
	var options = {};
	options.id = '#calendar-test-2';
	options.month_count = 2;
	var calendar_2 = new OC__Property_calendar_2(options);
	
	//console.log('CALENDAR', calendar_2, calendar_2.booking_data);
		
});
